export const defaultProps = {
  easing: "cubic-bezier(0.5, 0, 0, 1)",
  distance: "24px",
  duration: 800,
  desktop: true,
  mobile: true,
};

export const targetElements = [
  {
    element: ".section-title",
    animation: {
      delay: 300,
      distance: "0px",
      origin: "bottom",
    },
  },
  {
    element: ".hero-title",
    animation: {
      delay: 350,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".hero-intro",
    animation: {
      delay: 550,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".hero-cta",
    animation: {
      delay: 850,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".pixel-stage",
    animation: {
      delay: 800,
      origin: window.innerWidth > 768 ? "right" : "bottom",
    },
  },
  {
    element: ".spec-row",
    animation: {
      delay: 400,
      interval: 110,
      origin: "bottom",
    },
  },
  {
    element: ".section-note",
    animation: {
      delay: 550,
      origin: "bottom",
    },
  },
  {
    element: ".around-strip",
    animation: {
      delay: 950,
      origin: "bottom",
    },
  },
  {
    element: ".contact-mail",
    animation: {
      delay: 450,
      origin: "bottom",
    },
  },
];
